export default __webpack_public_path__ + "static/media/intro.00ae9b81.mp4";